import { useMutation, useQuery } from "@tanstack/react-query";

import { scimApi } from "src/api/taktileApi";
import { queryClient } from "src/queryClient";

const scimTokenKeys = {
  all: (orgId: string) => ["scimTokens", orgId] as const,
};

export const useGetScimTokens = (orgId: string) => {
  return useQuery({
    queryKey: scimTokenKeys.all(orgId),
    queryFn: async () =>
      (
        await scimApi.getScimServiceAccountsApiV1OrganizationsOrganizationIdScimServiceAccountsGet(
          orgId,
        )
      ).data,
  });
};

export const useCreateScimToken = (orgId: string) => {
  return useMutation({
    mutationFn: () =>
      scimApi.createScimServiceAccountApiV1OrganizationsOrganizationIdScimServiceAccountsPost(
        orgId,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: scimTokenKeys.all(orgId) });
    },
  });
};
